import React, { useRef, useState } from 'react';
import { useAnimation } from '../../useAnimation';
import { useGraphicData, updateGfxProps } from '../../useGraphicData';
const createDefaultDesiredPath = (graphicProps) => {
    if (graphicProps) {
        return ['default', graphicProps.preset, graphicProps.adSize ? `${graphicProps.adSize}Ad` : undefined].filter(val => val);
    }
    return [];
};
export function Graphic({ template: Template, animationList, graphicProps, fieldDataSpec, getAnimPath, adTransformObject, delayMap, latestData, name, forceAnimationResetPaths = [], noAnimation, zIndex, triggerToGraphicData }) {
    const [needsReset, setNeedsReset] = useState(false);
    const refs = useRef(new Map());
    const setRef = (name) => (node) => node === null ? refs.current.delete(name) : refs.current.set(name, node);
    const desiredState = getAnimPath
        ? getAnimPath(graphicProps, latestData)
        : createDefaultDesiredPath(updateGfxProps(triggerToGraphicData ? triggerToGraphicData(latestData, graphicProps) : graphicProps, latestData));
    // This is presented to useAnimation prior to be allowed to go through to the graphics to trigger the next animation
    const nextFieldData = useGraphicData(fieldDataSpec, graphicProps, true, latestData, triggerToGraphicData, true);
    const { animating, direction, state, to } = useAnimation(animationList, desiredState, refs, delayMap, nextFieldData, noAnimation, needsReset);
    // Graphic will be animating on next render. This is used to block data from updating prior to the graphic
    // starting to animate. The difference between reported state and desired state implies a future animation.
    // const awaitingChange = desiredState.join() !== state.join();
    const awaitingHide = desiredState.join() !== state.join() && desiredState.length <= state.length;
    // const animateOnFinish = (to?.toString() !== desiredState.join());
    // If the graphic is not animating or expanding then it can update its data.
    const animatingForwardOrStationary = !animating || direction !== -1;
    const fieldData = useGraphicData(fieldDataSpec, graphicProps, !animating && !awaitingHide && animatingForwardOrStationary, latestData, triggerToGraphicData, true);
    /*
     console.log(fieldData);
     console.log(latestData);
    */
    return (React.createElement("div", { style: { zIndex, position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' } }, (state === null || state === void 0 ? void 0 : state.length) || (desiredState === null || desiredState === void 0 ? void 0 : desiredState.length) || (to === null || to === void 0 ? void 0 : to.length) ? (React.createElement(Template, { adTransformObject: adTransformObject, 
        // @ts-ignore
        fieldData: fieldData || {}, graphicProps: graphicProps, nextStatePath: to, desiredStatePath: state, refs: refs, setRef: setRef })) : null));
}
//# sourceMappingURL=index.js.map